export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.team_types) {
        return {...state, ...payload.team_types};
      }
      return state;
    }
  }
};
